__turbopack_context__.v({
  "active": "TrapezoidTabs-module-scss-module__3c4cqq__active",
  "dropdownChevron": "TrapezoidTabs-module-scss-module__3c4cqq__dropdownChevron",
  "dropdownIcon": "TrapezoidTabs-module-scss-module__3c4cqq__dropdownIcon",
  "iconWrapper": "TrapezoidTabs-module-scss-module__3c4cqq__iconWrapper",
  "mobileDropdown": "TrapezoidTabs-module-scss-module__3c4cqq__mobileDropdown",
  "mobileSelect": "TrapezoidTabs-module-scss-module__3c4cqq__mobileSelect",
  "tab": "TrapezoidTabs-module-scss-module__3c4cqq__tab",
  "tabContent": "TrapezoidTabs-module-scss-module__3c4cqq__tabContent",
  "tabLabel": "TrapezoidTabs-module-scss-module__3c4cqq__tabLabel",
  "tabs": "TrapezoidTabs-module-scss-module__3c4cqq__tabs",
});
